import { editorContentShiftViewState } from "../..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setshowShiftTimeNotification", function setshowShiftTimeNotification(isVisible: boolean) {
    editorContentShiftViewState().showShiftTimeUpdatedNotification = isVisible;
});
